import {definePlugin} from 'sanity'

import {type RichDateDefinition, richDateSchema, type RichDateSchemaType} from './schema'
import type {RichDate} from './types'

export const richDate = definePlugin({
  name: 'v3-rich-date-input',
  schema: {
    types: [richDateSchema],
  },
})

export type {RichDate, RichDateDefinition, RichDateSchemaType}
